import type { CmsSitewideBannerData, CmsSitewideBannerProps } from "@chewy/cms-sitewide-banner";
import { type JSX, lazy, useState, useMemo } from "react";

import SitewideBannerModal from "./Modal/SitewideBannerModal";
// Lazy load components
const SitewideBanner = lazy(() => import("@chewy/cms-sitewide-banner"));

type CmsSitewideBannerComponentProps = {
  data: CmsSitewideBannerData;
  options?: CmsSitewideBannerProps;
};

const SitewideBannerWrapper = ({ data, ...props }: CmsSitewideBannerComponentProps): JSX.Element => {
  const [showModal, setShowModal] = useState(false);
  const hasModal = data.ctaOptions === "modal-popup";
  const modalImageSrcSet = useMemo(() => {
    if (hasModal && data.modalImages?.default) {
      return data.modalImages.default
        .reduce((srcSet: string[], image) => {
          if (image.imageType && ["1x", "2x"].includes(image.imageType)) {
            srcSet.push(`${image.url} ${image.imageType}`);
          }
          return srcSet;
        }, [])
        .join(", ");
    }
    return "";
  }, [data, hasModal]);
  return (
    <>
      <SitewideBanner
        {...props}
        aria-haspopup={hasModal ? "dialog" : "false"}
        data={data}
        onClick={() => hasModal && setShowModal(true)}
      />
      {hasModal && (
        <SitewideBannerModal show={showModal} setShow={setShowModal}>
          <img
            src={data.modalImages.default?.[0]?.url ?? undefined}
            srcSet={modalImageSrcSet}
            alt={data.modalImageAltText}
          />
        </SitewideBannerModal>
      )}
    </>
  );
};

export default SitewideBannerWrapper;
